// Angular
import { Component, Input, HostListener, ViewChild, OnInit } from '@angular/core';

// Angular Material
import { MatDialog } from '@angular/material/dialog';

// components
import { ImportGuestDialogComponent } from '@app/components/import-guest-dialog/import-guest-dialog.component';

@Component({
  selector: 'oh-admin-guest-details',
  templateUrl: './admin-guest-details.component.html',
  styleUrls: ['./admin-guest-details.component.scss'],
})
export class AdminGuestDetailsComponent implements OnInit {
  public unimportedHelpText: string;
  public pendingHelpText: string;
  public excludeHelpText: string;
  public importedHelpText: string;
  public otherAgentHelpText: string;
  @Input() openHouse: any;
  @Input() selectedGuest: any;
  @Input() questions: any;
  @Input() allowImport: boolean;
  @ViewChild('tooltip') tooltip: any;

  constructor(private dialog: MatDialog) {}

  async ngOnInit() {    
    this.unimportedHelpText = "This guest has not been imported into the DeltaNET®";
    this.pendingHelpText = "This guest is queued for import into the DeltaNET®";
    this.excludeHelpText = "This guest is already working with another agent and cannot be imported into the DeltaNET®";
    this.importedHelpText = "This guest was successfully imported into the DeltaNET®";
    this.otherAgentHelpText = "Represented by Another Agent question";
  }

  @HostListener('window:touchmove')
  @HostListener('scroll')
  private hideTooltip() {
    if (this.allowImport) { // Make sure tooltip exists before attempting to hide it
      this.tooltip.hide(0);
    }
  }

  public async importGuest(openID, guest) {
    this.dialog.open(ImportGuestDialogComponent, {
      width: '450px',
      data: {
        'open_id': openID,
        guest
      }
    });
  }

}
